export default __webpack_public_path__ + "static/media/newEdit.ac2a2167.svg";